(function TourSheets($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('TourSheets/index', function onload() {
			$("#tour_sheet_filter_criteria .remove").click(function removeCriteriaSent(event) {
				removeFilterCriteria('sent', $(this));
			});
		});
	});

	function removeFilterCriteria(action, $el)
	{
		var filter_key   = $el.data('filter-key'),
		    filter_value = $el.data('filter-value'),
		    url          = Adzuki.base_uri + '/TourSheets/removeFilterCriteria/' + action + '/' + filter_key;

		if (filter_value !== undefined) {
			url += '/' + filter_value;
		}
		window.location.href = url;
	}
}(jQuery, window.Adzuki || {}));
